import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import * as yup from 'yup'
import { updateUserInformation } from '../actions/AuthAction'
import { yupToFormErrors } from '../components/Validator'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { Button, Form, TextField } from './../components'
import { REQUIRED_FIELD } from './../utils/validation/constants'
import AuthContent from './AuthContent'

class RegisterView extends React.Component {
  static propTypes = {
    getTacRequest: PropTypes.func,
    updateUserInformation: PropTypes.func,
    error: PropTypes.any,
    property: PropTypes.any,
    tac: PropTypes.any,
    newUser: PropTypes.object,
  }

  state = {
    firstname: '',
    lastname: '',
    inputValidation: {},
  }

  validation = yup.object({
    firstname: yup.string().required(REQUIRED_FIELD),
    lastname: yup.string().required(REQUIRED_FIELD),
  })

  onValueChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  resetErrors = () => {
    this.setState({
      inputValidation: {},
    })
  }

  onVerifyAccount = async event => {
    event.preventDefault()
    this.resetErrors()

    const payload = {
      firstname: this.state.firstname,
      lastname: this.state.lastname,
    }

    try {
      await this.validation.validate(this.state, { abortEarly: false })
      await this.props.updateUserInformation(payload)
      routeService.goToPath(routeService.getPrefixPath() + '/')
    } catch (error) {
      if (error.inner) {
        const validationErrors = yupToFormErrors(error)
        this.setState({
          inputValidation: validationErrors,
        })
      } else if (error.serverError) {
        if (error.serverError.response.data.error.details && error.serverError.response.data.error.details.codes) {
          Object.keys(error.serverError.response.data.error.details.codes).map(key => {
            error.serverError.response.data.error.details.codes[
              key
            ] = error.serverError.response.data.error.details.codes[key]
              .map(code => translationService.formError(`${key}.${code}`))
              .join(', ')
          })

          this.setState({
            inputValidation: error.serverError.response.data.error.details.codes,
          })
        }
      }
    }
  }

  toggleModal = () => {
    this.setState(prevState => {
      return { tacModalisOpen: !prevState.tacModalisOpen }
    })
  }

  render() {
    const { error } = this.props
    const { inputValidation = {} } = this.state
    const processedErrors = error
    return (
      <AuthContent
        title={translationService.registerCompleteProfileTitle()}
        // subtitle={translationService.registerCompleteProfileIntro()}
        hasToken={false}
        withSpacer={false}>
        <Form onSubmit={this.onVerifyAccount}>
          <TextField
            label={translationService.registerFirstNameLabel()}
            id="firstname"
            autoFocus
            value={this.state.firstname}
            onChange={this.onValueChange}
            error={inputValidation.firstname || (processedErrors && processedErrors.firstname)}
          />
          <TextField
            label={translationService.registerLastNameLabel()}
            id="lastname"
            value={this.state.lastname}
            onChange={this.onValueChange}
            error={inputValidation.lastname || (processedErrors && processedErrors.lastname)}
          />
          <div>
            <Button submit primary onClick={this.onVerifyAccount}>
              {translationService.system('next')}
            </Button>
          </div>
        </Form>
      </AuthContent>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { error, newUser } = AuthReducer
  const { property } = FlowReducer

  return {
    property,
    error,
    newUser,
  }
}
const mapDispatchToProps = dispatch => ({
  updateUserInformation: userInformation => dispatch(updateUserInformation(userInformation)),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(RegisterView)



// WEBPACK FOOTER //
// ./src/views/RegisterView.js